// CotizacionesRoutesXL - Sprint 44 Fase 3 Vista 4.
// Reemplaza modules/cotizaciones/routes.jsx. Rutas preservadas:
// /cotizaciones (index), /cotizaciones/nueva, /cotizaciones/:id.
import { Routes, Route } from 'react-router-dom';
import CotizacionesListXL from './CotizacionesListXL';
import CotizacionFormXL from './CotizacionFormXL';

export default function CotizacionesRoutesXL() {
  return (
    <Routes>
      <Route index element={<CotizacionesListXL />} />
      <Route path="nueva" element={<CotizacionFormXL />} />
      <Route path=":id" element={<CotizacionFormXL />} />
    </Routes>
  );
}
